import { render, staticRenderFns } from "./PortalAbonadosAvet.vue?vue&type=template&id=799cd87a"
import script from "./PortalAbonadosAvet.vue?vue&type=script&lang=js"
export * from "./PortalAbonadosAvet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports